import { View, Text } from "react-native";
import { ms } from "./moderateScale";
import { Colors } from "@/constants/Colors";
import Icon, { IconType } from "./Icon";
import { useUISlice } from "@/models/useUISlice";

export default function SelectorButton({
  leftIcon,
  text,
  rightIcon,
}: {
  leftIcon?: IconType;
  rightIcon?: IconType;
  text: string;
}) {
  const isMobile = useUISlice((state) => state.device.isMobile);

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        height: ms(40),
        backgroundColor: Colors.text + "10",
        borderRadius: ms(8),
        paddingHorizontal: ms(16),
        ...(isMobile && {
          height: ms(32),
        }),
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: ms(6),
        }}
      >
        {leftIcon && (
          <Icon icon={leftIcon} style={{ width: ms(16), height: ms(16) }} />
        )}
        <Text
          style={{
            fontSize: ms(14),
            color: Colors.accent,
            fontWeight: "500",
            marginRight: ms(4),
            ...(isMobile && {
              marginRight: ms(0),
            }),
          }}
        >
          {text}
        </Text>
      </View>
      {rightIcon && (
        <Icon
          icon={rightIcon}
          style={{
            width: ms(20),
            height: ms(20),
            tintColor: Colors.accent,
          }}
        />
      )}
    </View>
  );
}
